import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { apiFetch } from '../../api/client'

export interface NotificationPreferences {
  upcomingRemindersEnabled: boolean
  overdueRemindersEnabled: boolean
}

const key = ['notification-preferences'] as const

export function useNotificationPreferences() {
  return useQuery({
    queryKey: key,
    queryFn: () => apiFetch<NotificationPreferences>('/api/me/notification-preferences'),
  })
}

export function useUpdateNotificationPreferences() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (preferences: NotificationPreferences) =>
      apiFetch<void>('/api/me/notification-preferences', { method: 'PUT', body: preferences }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: key }),
  })
}
